<template>
	<div class="title-description">
		<h1>{{ title }}</h1>
		<p class="description">
			{{ description }}
			<span class="link-description" @click="$emit('handle-click')">{{
				linkDescription
			}}</span>
		</p>
	</div>
</template>

<script>
export default {
	name: 'TitleDescriptionLink',
	props: ['title', 'description', 'linkDescription'],
};
</script>

<style scoped lang="scss">
h1 {
	@include rem(margin, 0 0 8px 0);
}
.description {
	@include rem('line-height', 25px);
}

.link-description {
	text-decoration: underline;
	cursor: pointer;
}
</style>
